import api from "./api";
import { APIs } from "../constants/APIConstants";
import { GLOBAL_MEETING_DATA } from "../constants/PublicVariables";

export default class NotesAPIFunction {
    createNote(req) {
        return api.post(APIs.CREATE_NOTE.replace("{SessionId}", GLOBAL_MEETING_DATA.sessionId), req);
    }

    updateNote(req) {
        const noteId = req.noteId;
        delete req.noteId;
        return api.put(APIs.UPDATE_NOTE.replace("{SessionId}", GLOBAL_MEETING_DATA.sessionId).replace("{NoteId}", noteId), req);
    }

    deleteNote(req) {
        const noteId = req.noteId;
        delete req.noteId;
        return api.delete(APIs.DELETE_NOTE.replace("{SessionId}", GLOBAL_MEETING_DATA.sessionId).replace("{NoteId}", noteId), req);
    }
}
